import { render } from "./update-notification.vue?vue&type=template&id=2de7415a"
import script from "./update-notification.vue?vue&type=script&lang=js"
export * from "./update-notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__